<template>
  <div
    :class="`element element--statusled element--statusled--${name}`"
    :element-translation="i18n ? elementTranslation.found : elementTranslation.missing"
    :message-type="messageType || meaning.unkown"
  >
    <div class="element__led"></div>

    <label class="element__label">{{ i18n? $t(`${content}`): content }}</label>
  </div>
</template>

<script>
import { elementTranslation, meaning } from '../../tools/consts';
export default {
	props: {
		name: String,
		content: String,
		i18n: Boolean,
		messageType: String,
	},
	created() {
		this.elementTranslation = elementTranslation;
		this.meaning = meaning;
	},
};
</script>

